class YoutubeLink {
  constructor(url) {
    this.originalUrl = url
  }

  getVideoId() {
    if (!this.originalUrl) return null

    // Handle youtu.be short URLs first (most specific)
    // This ensures short URLs are handled correctly even if they contain other parameters
    if (this.originalUrl.includes('youtu.be/')) {
      const shortMatch = this.originalUrl.match(/youtu\.be\/([^/?&]+)/)
      return shortMatch ? shortMatch[1] : null
    }

    // Handle embed URLs like https://www.youtube.com/embed/ZQ7oqmikZDQ
    if (this.originalUrl.includes('/embed/')) {
      const embedMatch = this.originalUrl.match(/\/embed\/([^/?&]+)/)
      return embedMatch ? embedMatch[1] : null
    }

    // Handle watch URLs like https://www.youtube.com/watch?v=ZQ7oqmikZDQ (most general)
    // This also handles malformed URLs with duplicate query parameters
    if (this.originalUrl.includes('watch') && this.originalUrl.includes('v=')) {
      const vParamMatch = this.originalUrl.match(/[?&]v=([^&?]+)/)
      return vParamMatch ? vParamMatch[1] : null
    }

    return null
  }

  getVideoTime() {
    if (!this.originalUrl) return null

    // Try to parse time parameter from various formats
    const timeMatch = this.originalUrl.match(/[?&]t=([^&?]+)/) ||
                     this.originalUrl.match(/[?&]start=([^&?]+)/)
    return timeMatch ? timeMatch[1] : null
  }
}

export default YoutubeLink
